import { EMOJI_PATTERN, EMOJI_PATTERN_GLOBAL, descriptionEmojiError } from '@/constants'

/**
 * Emoji rules for descriptions.
 *
 * An emoji in an item description stops the item from listing, so description
 * templates and per-item descriptions refuse to save while they hold one.
 * Ordinary typography — digits, `#`, `*`, ©, ®, ™, accented letters, dashes,
 * bullets, quotes — is not emoji and passes; see `EMOJI_PATTERN` for where the
 * line is drawn.
 *
 * Works on plain text and on stored HTML alike: tags, attributes and
 * `{{placeholder}}` tokens never contain emoji, so only the text is affected.
 *
 * Patterns + error string live in `@/constants` (settings).
 */

/** True when `text` holds at least one emoji. Nullish is treated as empty. */
export const containsEmoji = (text) => EMOJI_PATTERN.test(String(text ?? ''))

/** The first emoji in `text`, or '' when there is none. */
export const firstEmoji = (text) => String(text ?? '').match(EMOJI_PATTERN)?.[0] ?? ''

/**
 * `text` with every emoji sequence removed. Nullish passes through untouched:
 * in a request body `undefined` means "field not sent", and turning it into ''
 * would blank the field instead.
 */
export const stripEmoji = (text) => text == null ? text : String(text).replace(EMOJI_PATTERN_GLOBAL, '')

/** The inline error a description earns, or '' when it is fine. */
export const descriptionEmojiInputError = (text) => {
  const emoji = firstEmoji(text)

  return emoji ? descriptionEmojiError(emoji) : ''
}
